/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Official_Contact_VisibilityInputs */



/**
* | output |
* | --- |
* | "Your contact info and community links are visible to all users." |
*
* @param {Profile_Official_Contact_VisibilityInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_official_contact_visibility = /** @type {((inputs?: Profile_Official_Contact_VisibilityInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Official_Contact_VisibilityInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vos informations de contact et liens communautaires sont visibles par tous les utilisateurs.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tu información de contacto y enlaces de comunidad son visibles para todos los usuarios.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Suas informações de contato e links da comunidade são visíveis para todos os usuários.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le tue informazioni di contatto e i link della comunità sono visibili a tutti gli utenti.")
	return /** @type {LocalizedString} */ ("Your contact info and community links are visible to all users.")
});